import { isOwnApiUrl } from "@/lib/preview-fetch";

interface VideoPreviewProps {
	url: string;
}

export function VideoPreview({ url }: VideoPreviewProps) {
	return (
		<div className="flex h-full items-center justify-center p-4">
			<video
				src={url}
				controls
				crossOrigin={isOwnApiUrl(url) ? "use-credentials" : undefined}
				className="max-h-full max-w-full rounded-4"
			/>
		</div>
	);
}
